import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";

import { WriteReviewComponent } from "@/components/Order/shared/OrderItem/components/WriteReview/writeReview.component";
import { ReviewsContextProvider } from "@/components/Product/Reviews/context/reviews.context";
import { WriteReviewContextProvider } from "@/components/Product/Reviews/context/writeReview.context";

type Props = {
    item: OrderItem;
    className?: string;
};

export const WriteReview = ({ item, className }: Props) => {
    return (
        <ReviewsContextProvider
            sku={item.sku}
            brand={item.product?.brandName ?? undefined}
        >
            <WriteReviewContextProvider sku={item.sku}>
                <WriteReviewComponent className={className} />
            </WriteReviewContextProvider>
        </ReviewsContextProvider>
    );
};
